import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import partial from 'lodash/partial';
import SingleEntry from 'single_entry/components';
import { fetchSingleEntry } from 'single_entry/ducks';
import { getProjectIdFromUrl } from 'project/utils';
import { getProject } from 'project/ducks/project';
import { fetchProjectEntriesIfNeeded } from 'project/ducks/entries';

SingleEntry.need = [
  params => fetchProjectEntriesIfNeeded({ projectId: getProjectIdFromUrl(params) })
];

export function mapStateToProps(state, { params }) {
  const { single_entry, user } = state;
  const entry = single_entry.entriesById[params.entryId];
  const project = getProject(state);

  return {
    ...single_entry,
    viewDisallowed: !user.logged_in && project.search_exclusion,
    entry,
  };
}

export function mapDispatchToProps(dispatch, { params, location }) {
  const projectId = getProjectIdFromUrl(params);
  const revisionId = location.query.revision? parseInt(location.query.revision) : undefined;

  return bindActionCreators({
    fetch: partial(fetchSingleEntry, projectId, params.entryId, revisionId),
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SingleEntry));



// WEBPACK FOOTER //
// ./single_entry/containers/index.js